import { BehaviorSubject } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import Case, { defaultCase } from '../models/Case';
import { WorkspaceProductType } from '../models/Workspace';

export const casesDefaultCriteria = {
  isDueSoon: defaultCase.includes('delayed'),
  limit: 10,
  orderField: null,
  orderType: 'ASC',
  page: 0,
  status: defaultCase.join(','),
};

export default class CasesBloc {
  cases$ = new BehaviorSubject([]);
  total$ = new BehaviorSubject(0);
  searchCriteria$ = new BehaviorSubject(casesDefaultCriteria);
  defaultCase$ = new BehaviorSubject(defaultCase);
  searchSubscription;

  constructor({ casesRepository, userRepository, authRepository }) {
    this.casesRepository = casesRepository;
    this.userRepository = userRepository;
    this.authRepository = authRepository;

    this.updateDefaultSearchCriteria();

    this.searchSubscription = this.searchCriteria$.subscribe(() => {
      this.getCases();
    });
  }

  async getCases() {
    const cases = await this.casesRepository.getCases(this.searchCriteria$.getValue());
    cases.data = cases.data.map((item) => new Case(item));
    this.cases$.next(cases.data);
    this.total$.next(cases.total);
  }

  get shouldOpenCreatorDashboard$() {
    return this.userDetails$.pipe(
      filter((e) => e),
      map((userDetails) => {
        return ['creator', 'trainee'].includes(userDetails.role) && userDetails.workspace.productType === WorkspaceProductType.whiteGlove.value;
      })
    );
  }

  dispose() {
    this.searchSubscription.unsubscribe();
  }

  updateSearchCriteria(updatedCriteria) {
    const nextCriteria = {
      ...this.searchCriteria$.getValue(),
      ...updatedCriteria,
    };

    if (!updatedCriteria?.page) nextCriteria.page = 0;

    this.searchCriteria$.next(nextCriteria);
  }

  async getSelectedCase(id) {
    const caseStudy = await this.casesRepository.getCase(id);
    const frameUrl = await this.casesRepository.getLinkViewer(id);
    caseStudy.viewerLink = frameUrl.viewerLink;
    this.casesRepository.selectedCase$.next(new Case(caseStudy));
  }

  get userDetails$() {
    return this.userRepository.userDetails$;
  }

  get userWorkspace$() {
    return this.authRepository.userWorkspace$;
  }

  updateDefaultSearchCriteria() {
    const userDetails = this.userDetails$.getValue();
    let shouldUpdateDefaultCriteria = false;

    if (['creator', 'trainee'].includes(userDetails?.role)) shouldUpdateDefaultCriteria = true;
    if (!userDetails?.workspace?.isMediphanyWorkspace && userDetails?.role !== 'super-admin') shouldUpdateDefaultCriteria = true;

    if (!shouldUpdateDefaultCriteria) return;

    const statusList = [
      'pending-upload',
      'upload-shared',
      'pending-images',
      'new',
      'delayed',
      'uploading',
      'in-progress',
      'review',
      'in-review',
      'completed',
      'incomplete',
      'not-paid',
      'archived',
    ];
    this.defaultCase$.next(statusList);
    this.updateSearchCriteria({
      status: statusList.join(','),
    });
  }
}
